import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=2e136cd2&scoped=true"
import script from "./EditableText.vue?vue&type=script&lang=js"
export * from "./EditableText.vue?vue&type=script&lang=js"
import style0 from "./EditableText.vue?vue&type=style&index=0&id=2e136cd2&prod&lang=scss&scoped=true"
import style1 from "./EditableText.vue?vue&type=style&index=1&id=2e136cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e136cd2",
  null
  
)

export default component.exports